import { EXPLORE_FILTERS, type ExploreFilter } from './exploreModel';

/** Shared selection for desktop/tablet controls and the mobile navigation dock. */
export function ExploreFilters({
  filter,
  onFilter,
}: {
  filter: ExploreFilter;
  onFilter: (filter: ExploreFilter) => void;
}) {
  return (
    <div className="explore-filters" role="group" aria-label="Filter Explore">
      {EXPLORE_FILTERS.map((item) => (
        <button
          key={item}
          type="button"
          aria-pressed={filter === item}
          onClick={() => onFilter(item)}
        >
          {item}
        </button>
      ))}
    </div>
  );
}
